module.exports = __webpack_public_path__ + "img/G-2-952x410.a2a0f49c.png";